import config from './config.js'

export default {

  user: false,

  // user login
  login: function(user,password) {
    return fetch(config.baseUrl + 'rest/security/login',
      {
        method: 'POST',
        body: JSON.stringify({login: user,password: password}),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      })
  },
  // end session
  logout: function() {
    return fetch(config.baseUrl + 'rest/security/logout', {
      credentials: 'include'
    })
  },
  // check current session
  whoami: function() {
    var self = this;
    return fetch(config.baseUrl + 'rest/security/whoami',{
      credentials: 'include'
    }).then(resp => resp.json()).then(function(data) {
      self.user = data;
      console.log('updated user: ',data);
      return data;
    })
  },


}
